import React from 'react';
import { useIntl } from 'react-intl';

import { BannerStatus, BannerLayout } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';

import style from './picking-exception-alert.module.less';
import { formatPickingExceptionMessage } from './picking-exception-helpers';
import { useEnablePickingExceptions } from '../../../../../feature-flags/hooks/use-enable-picking-exceptions';

import type { Reporter } from './types';

type PickingExceptionAlertProps = {
  row: {
    original: {
      fulfillmentPlanItemId?: string;
      pickingExceptionMessage?: string;
      pickingExceptionReporter?: Reporter | null;
    };
  };
};

export const PickingExceptionAlert = ({ row }: PickingExceptionAlertProps) => {
  const intl = useIntl();
  const isPickingExceptionsEnabled = useEnablePickingExceptions();
  const { pickingExceptionMessage, pickingExceptionReporter } = row.original;

  if (!isPickingExceptionsEnabled || !pickingExceptionMessage) {
    return null;
  }

  const reasons = pickingExceptionMessage
    .split(';')
    .map((s) => s.trim())
    .filter(Boolean);

  if (reasons.length === 0) {
    return null;
  }

  const messageText = formatPickingExceptionMessage(intl, reasons, pickingExceptionReporter);

  return (
    <BannerMessageV2
      className={style['picking-exception-alert']}
      content={messageText}
      layout={BannerLayout.Inline}
      status={BannerStatus.Warning}
    />
  );
};
